import React from 'react';

import { wrapper } from './styles';
import { center } from '../../styles';

class Loader extends React.Component {
  render() {
    return (
      <div {...wrapper} {...center}>
        <h1>Loading</h1>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js